import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

/**
 * Провайдер языка для всего приложения
 * Сохраняет выбранный язык в localStorage
 */
export function LanguageProvider({ children }) {
  // Получаем язык из localStorage или используем русский по умолчанию
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('app_language');
    // Проверяем, что сохраненный язык поддерживается
    if (saved && ['ru', 'en'].includes(saved)) {
      return saved;
    }
    // Определяем язык браузера
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang.startsWith('en')) {
      return 'en';
    }
    return 'ru'; // По умолчанию русский
  });

  // Сохраняем язык в localStorage при изменении
  useEffect(() => {
    localStorage.setItem('app_language', language);
  }, [language]);

  const changeLanguage = (newLanguage) => {
    if (['ru', 'en'].includes(newLanguage)) {
      setLanguage(newLanguage);
    }
  };

  const value = {
    language,
    changeLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

/**
 * Хук для использования языка в компонентах
 * @returns {object} { language, changeLanguage }
 */
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

